Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="formio-dialog formio-dialog-theme-default component-settings">\n  <div class="formio-dialog-overlay" ref="dialogOverlay"></div>\n  <div class="formio-dialog-content" ref="dialogContents">\n    <div ref="dialogContents"></div>\n    <button class="formio-dialog-close float-right btn btn-secondary btn-sm" aria-label="close" ref="dialogClose"></button>\n  </div>\n</div>\n';
return __p
}